import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Layout from "../layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { IoAddCircle } from "react-icons/io5";

const PabrikList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);
  const [dataPabrik, setDataPabrik] = useState([]);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    const fetchDataPabrik = async () => {
      const token = localStorage.getItem("token");

      try {
        const response = await axios.get(
          `https://c-greenproject.org:8000/pabrik`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setDataPabrik(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDataPabrik();
  }, []);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (
      user &&
      user.role !== "pabrik" &&
      user.role !== "admin" &&
      user.role !== "perusahaan"
    ) {
      navigate("/");
    }
  }, [isError, user, navigate]);

  const deleteDataPabrik = async (id) => {
    const confirmDelete = window.confirm("Yakin ingin menghapus data pabrik ini?");
    if (!confirmDelete) return;
  
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`https://c-greenproject.org:8000/pabrik/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setDataPabrik(dataPabrik.filter((pabrik) => pabrik.id !== id));
    } catch (error) {
      console.error("Gagal menghapus data pabrik:", error);
    }
  };
  

  const formatNumber = (number) => {
    return number.toLocaleString("id-ID");
  };

  return (
    <Layout>
      <Container>
        <h2 className="title mb-4">
          <strong>Data Pabrik</strong>
        </h2>
        {user && (user.role === "admin" || user.role === "pabrik") && (
          <Link to="/data-pabrik/add" className="btn btn-primary mb-4">
            <IoAddCircle /> Add Data Pabrik
          </Link>
        )}
        {dataPabrik.length > 0 ? (
          dataPabrik.map((pabrik) => (
            <Card key={pabrik.id} className="mb-4 shadow-sm p-4">
              <Row>
                {user &&
                  (user.role === "admin" || user.role === "perusahaan") && (
                    <>
                      <Col md={4}>
                        <h5 className="fw-bold">Nama Pabrik</h5>
                      </Col>
                      <Col md={8}>
                        <p>{pabrik?.user?.name || "-"}</p>
                      </Col>

                      <Col md={4}>
                        <h5 className="fw-bold">Email Pabrik</h5>
                      </Col>
                      <Col md={8}>
                        <p>{pabrik?.user?.email || "-"}</p>
                      </Col>

                      <Col md={4}>
                        <h5 className="fw-bold">User ID Pabrik</h5>
                      </Col>
                      <Col md={8}>
                        <p>{pabrik?.uuid || "-"}</p>
                      </Col>
                    </>
                  )}

                <Col md={4} className="mb-1 fw-bold text-muted">
                  ID Data Pabrik
                </Col>
                <Col md={8}>
                  <p>{pabrik?.iddatadasarpbk || "-"}</p>
                </Col>

                <Col md={4} className="mb-1 fw-bold text-muted">
                  Kapasitas RAMP
                </Col>
                <Col md={8}>{formatNumber(pabrik?.kapasitasram)} kg</Col>

                <Col md={4} className="mb-1 fw-bold text-muted">
                  Kapasitas Produksi
                </Col>
                <Col md={8}>{formatNumber(pabrik?.kapasitasproduksi)} kg</Col>

                <Col md={4} className="mb-1 fw-bold text-muted">
                  Catatan Produksi Pabrik
                </Col>
                <Col md={8}>{pabrik?.memproduksi || "-"}</Col>
              </Row>

               <div className="mt-3">
                {user.role === "admin" && (
                  <Button
                    variant="danger"
                    onClick={() => deleteDataPabrik(pabrik.id)}
                  >
                    Delete
                  </Button>
                )}
              </div> 
            </Card>
          ))
        ) : (
          <p>Memuat data...</p>
        )}
      </Container>
    </Layout>
  );
};

export default PabrikList;
